import { Popup } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { FormPopupContent } from './components';
import { useXeroAccrualReportPopup } from './XeroAccrualReportPopup.hooks';
import { XeroAccrualReportPopupProps } from './XeroAccrualReportPopup.types';

export const XeroAccrualReportPopup = memo<XeroAccrualReportPopupProps>((props) => {
    const { reportConfig } = props;

    const { isOpen, handleClose } = useXeroAccrualReportPopup();

    return (
        <Popup size='large' open={isOpen} onToggle={handleClose}>
            <FormPopupContent reportConfig={reportConfig} />
        </Popup>
    );
});

XeroAccrualReportPopup.displayName = 'XeroAccrualReportPopup';
